import { tss } from 'tss-react/mui';

const useStyles = tss.create(({ theme }) => ({
  asset: {
    height: 'auto',
    paddingBottom: '20px',
    marginBottom: '200px',
    minHeight: 'max-content',
    [theme.breakpoints.down('sm')]: {
      marginBottom: '18rem'
    }
  },
  assetConnectivitySectionHeader: {
    fontWeight: 600,
    padding: '0rem 1rem',
    minHeight: '3rem',
    alignContent: 'center',
    backgroundColor: theme.vars.palette.background.elevation2,
    borderBottom: `1px solid ${theme.vars.palette.divider}`,
    borderRadius: '4px 4px 0 0',
    boxShadow: 'none'
  },
  assetConnectivitySection: {
    boxShadow: theme.shadows[2],
    borderRadius: '4px'
  },
  assetConnectivityTableWrapper: {
    width: '33%',
    backgroundColor: theme.vars.palette.background.elevation2,
    height: 'min-content',
    overflow: 'hidden',
    [theme.breakpoints.down('lg')]: {
      marginBottom: '3rem !important',
      marginLeft: 0,
      width: '100%'
    },
    [theme.breakpoints.down('md')]: {
      marginBottom: '7rem !important'
    }
  },
  assetTopContainer: {
    minHeight: 'min-content',
    alignItems: 'stretch'
  },
  assetSidebarContainer: {
    height: 'auto',
    width: '33%',
    minWidth: '33%',
    marginLeft: '1rem',
    [theme.breakpoints.down('md')]: {
      marginBottom: '2rem',
      marginLeft: 0,
      width: '100%'
    }
  },
  assetTableHeader: {
    height: 48,
    alignContent: 'center',
    padding: '0 1rem',
    backgroundColor: theme.vars.palette.background.elevation2,
    borderBottom: `1px solid ${theme.vars.palette.divider}`,
    borderRadius: '4px 4px 0 0'
  },
  vulnerabilitiesTableContainer: {
    height: '35rem',
    width: '100%',
    display: 'flex',
    flexDirection: 'column'
  },
  externalDetailsBox: {
    backgroundColor: theme.vars.palette.background.elevation2,
    width: '100%',
    maxWidth: '100%',
    height: 'min-content',
    flexGrow: 1
  },
  externalDetailsCardHeader: {
    alignItems: 'center',
    borderBottom: `1px solid ${theme.vars.palette.divider}`,
    display: 'flex',
    fontWeight: 600,
    justifyContent: 'space-between',
    padding: '.75rem 1.18rem .75rem 1rem',
    height: '48px',
    '& h4': {
      margin: '0'
    },
    '& > .MuiCardHeader-content': {
      alignItems: 'center',
      display: 'flex',
      flex: '1 1 0%',
      minWidth: 0,
      marginRight: theme.spacing(1)
    },
    '& > .MuiCardHeader-action': {
      flexShrink: 0,
      alignSelf: 'center',
      marginTop: 0,
      marginLeft: 'auto'
    }
  },
  worldMapChartContainer: {
    width: 'calc(67% - 24px)',
    flex: 1,
    backgroundColor: theme.vars.palette.background.elevation2,
    [theme.breakpoints.down('lg')]: {
      width: '100%'
    }
  },
  assetSectionTitle: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    fontSize: '1rem',
    fontWeight: 'bold',
    borderRadius: '4px',
    '& .MuiCardHeader-title': {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      fontSize: '1rem !important',
      fontWeight: 'bold !important'
    }
  },
  assetVulnerabilitiesTableContainer: {
    borderRadius: '0px 0px 4px 4px',
    boxShadow: theme.shadows[2],
    flexGrow: 1,
    '& .ag-wrapper': {
      borderRadius: '4px'
    },
    '& .ag-root-wrapper': {
      borderRadius: '0 0 4px 4px'
    }
  },
  assetRemediationTableContainer: {
    height: '17rem',
    fontSize: '1rem',
    fontWeight: 'bold',
    borderRadius: '4px',
    boxShadow: theme.shadows[2],
    '& .MuiCardHeader-title': {
      fontSize: '1rem !important',
      fontWeight: 'bold !important'
    }
  }
}));

export default useStyles;
